import React from 'react';

const VerifyEmail: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900">Verify Email</h1>
        <p className="text-gray-600 mt-2">Email verification functionality will be implemented here.</p>
      </div>
    </div>
  );
};

export default VerifyEmail;
